export const namespaces = [
    'common',
    'header',
    'home',
    'auth',
    'footer',
    'contact',
    'enums',
    'training',
    'blog',
    'video',
    'broadcast',
    'consulting',
    'aboutUs',
    'marketResearch',
    'strategy',
    'businessModel',
    'salesSystem',
    'marketingSystem',
    'humanResources',
    'jobAnalysis',
    'managementStructure',
    'responsibilities',
    'salarySystem',
    'performanceSystem',
    'recruitment',
    'userMenu',
    'consultingMenu',
    'eventsMenu',
    'satForum',
    'businessAdministration',
    'strategicHrForum',
    'leagueOfCompanies',
    'vendorFactory',
    'masterClass',
    'login',
    'courses',
    'error',
    'confirmDialog',
    'registration',
];
